import Button from 'components/button/Button';
import { Modal } from 'react-bootstrap';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface OwnerModalFooterProps {
  isEdit: boolean;
  onClose: () => void;
}

const OwnerModalFooter = ({ isEdit, onClose }: OwnerModalFooterProps) => {
  const { t } = useTranslation();
  const { isSubmitting, isDirty } = useFormState();

  const isDisabled = isSubmitting || !isDirty;

  return (
    <Modal.Footer>
      <Button bsStyle="default" onClick={onClose}>
        {t('common.cancel')}
      </Button>
      <Button bsStyle="primary" type="submit" disabled={isDisabled}>
        {isEdit ? t('common.save') : t('pageProperty.owners.modal.addTitle')}
      </Button>
    </Modal.Footer>
  );
};

export default OwnerModalFooter;
